import carStatistics from '../CarStatistics';
import organStatistics from '../OrganStatistics';
import eventStatistics from '../EventStatistics';
import goodsTypeStatistics from '../GoodsTypeStatistics'
/**
 *数据路由
 */
const query = [
    {
        name: '按车辆统计',
        path: '/query/carStatistics',
        component: carStatistics
    },
    {
        name: '按医疗机构统计',
        path: '/query/organStatistics',
        component: organStatistics
    },
    {
        name: '按医废种类统计',
        path: '/query/goodsTypeStatistics',
        component: goodsTypeStatistics
    },
    {
        name: '按事件查询',
        path: '/query/eventStatistics',
        component: eventStatistics
    },
];
export default query
